import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "zd_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const login = async (email, password, totpCode) => {
  const { data } = await axios.post(`${API}/auth/login`, {
    email,
    password,
    totp_code: totpCode || undefined,
  });
  if (data.mfa_required) return data; // no token yet — second factor needed
  setToken(data.token);
  return data;
};

export const logout = () => clearToken();

export const me = () => adminApi.get("/auth/me").then((r) => r.data);
export const forgotPassword = (email) =>
  axios.post(`${API}/auth/forgot-password`, { email }).then((r) => r.data);
export const resetPassword = (token, new_password) =>
  axios.post(`${API}/auth/reset-password`, { token, new_password }).then((r) => r.data);
export const changePassword = (current_password, new_password) =>
  adminApi.post("/auth/change-password", { current_password, new_password }).then((r) => r.data);
export const mfaSetup = () => adminApi.post("/auth/mfa/setup").then((r) => r.data);
export const mfaEnable = (code) => adminApi.post("/auth/mfa/enable", { code }).then((r) => r.data);
export const mfaDisable = (password) => adminApi.post("/auth/mfa/disable", { password }).then((r) => r.data);
export const mfaCancel = () => adminApi.post("/auth/mfa/cancel").then((r) => r.data);

export const listLeads = (includeArchived = false) =>
  adminApi.get("/admin/leads", { params: { include_archived: includeArchived } }).then((r) => r.data);
export const getLeadStats = () => adminApi.get("/admin/stats").then((r) => r.data);
export const updateLead = (id, patch) => adminApi.patch(`/admin/leads/${id}`, patch).then((r) => r.data);
export const archiveLead = (id, archived = true) =>
  adminApi.patch(`/admin/leads/${id}`, { archived }).then((r) => r.data);
export const deleteLead = (id) => adminApi.delete(`/admin/leads/${id}`).then((r) => r.data);

export const getContent = (key) => adminApi.get(`/content/${key}`).then((r) => r.data);
export const getAllContent = () => adminApi.get(`/content`).then((r) => r.data);
export const setContent = (key, value) => adminApi.put(`/admin/content/${key}`, value).then((r) => r.data);

export const uploadMedia = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await adminApi.post("/admin/media", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data; // { id, url, size, content_type }
};
export const listMedia = () => adminApi.get("/admin/media").then((r) => r.data);
export const deleteMedia = (id) => adminApi.delete(`/admin/media/${id}`).then((r) => r.data);
